module.exports = __webpack_public_path__ + "img/quantity@2x.47e1e2d6.png";